import { ReactNode } from 'react';
import { Link } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useEmptyViewStyles } from './empty-view.styles';

type EmptyViewProps = {
  icon?: ReactNode;
  heading: string;
  description: string;
  emptyHelpLinkTitle?: string;
  emptyHelpLink?: string;
};

export const EmptyView = ({
  icon,
  heading,
  description,
  emptyHelpLinkTitle,
  emptyHelpLink,
}: EmptyViewProps) => {
  const classes = useEmptyViewStyles();
  const configApi = useApi(configApiRef);

  return (
    <Box className={classes.emptyContainer}>
      <Box className={classes.emptyItems}>
        {icon && <Box data-testid="empty-icon-container">{icon}</Box>}

        <Box>
          <Typography className={classes.emptyHeading}>{heading}</Typography>
        </Box>

        <Box>
          <Typography className={classes.emptyDescription}>
            {description}
          </Typography>
        </Box>
        {emptyHelpLink && emptyHelpLinkTitle && (
          <Link
            to={`${configApi.getOptionalString('app.baseUrl')}${emptyHelpLink}`}
            externalLinkIcon
            className={classes.emptyHelpLink}
          >
            {emptyHelpLinkTitle}
          </Link>
        )}
      </Box>
    </Box>
  );
};
